import JsFunction from './JsFunction';

function getHtmlTableAttributes({ tableAttributes, htmlDom }) {
  return tableAttributes.reduce((mapAttrElements, attr) => {
    const htmlElementsAnnotation = [...htmlDom.querySelectorAll(`[annotationName=${attr}]`)];
    const htmlElementsInputArray = [
      ...htmlElementsAnnotation.map((element) => [...element.querySelectorAll(`[arrayinput]`)])
    ].flat();
    if (htmlElementsInputArray.length === 1)
      mapAttrElements.set(attr, `array${htmlElementsInputArray[0].getAttribute('id')}`);

    return mapAttrElements;
  }, new Map());
}

export default class UpdateFunction extends JsFunction {
  inputTemplate = (attr, element) => {
    if (this.effectingHtmlElements[attr] && this.returnAttributeType(attr) === 'image') {
      return `['${attr}'] = {
        data: document.querySelector("[annotationname = '${attr}']").getAttribute("data-image-base64") !== null ? document.querySelector("[annotationname = '${attr}']").getAttribute("data-image-base64") : document.querySelector("[annotationname = '${attr}']").src,
        name: document.querySelector("[annotationname = '${attr}']").getAttribute("name")
      };`;
    }
    if (this.effectingHtmlElements[attr] && this.returnAttributeType(attr) === 'date')
      return `['${attr}'] = document.querySelector("[annotationname = '${attr}']").${element}.replace(/(?<day>\\d+)-(?<month>\\d+-)/,'$<month>$<day>-');`;
    if (this.effectingHtmlElements[attr] && this.returnAttributeType(attr) === 'radiobox')
      return `['${attr}'] = document.querySelector("[annotationname = '${attr}']:checked").value;`;
    if (this.effectingHtmlElements[attr])
      return `['${attr}'] = document.querySelector("[annotationname = '${attr}']").${element};`;
    if (this.effectingArrayInputElements[attr])
      return `['${attr}'] = ${element}.map(item => item.value);`;
    return '/** something went wrong */;';
  };

  outputTemplate = (attr, element) => {
    if (this.effectingHtmlElements[attr] && this.returnAttributeType(attr) === 'image') {
      return `
      if(response.body.query.${attr} !== undefined){

        if(document.querySelector('[annotationname = ${attr}]').getAttribute('type') === 'file'){
          document.querySelector('[annotationname = ${attr}]').setAttribute('data-image-base64',response.body.query.${attr}.data);
        }
        else{
          document.querySelector('[annotationname = ${attr}]').src = response.body.query.${attr}.data;
        }
        document.querySelector('[annotationname = ${attr}]').name = response.body.query.${attr}.name;
      }
      `;
    }
    if (this.effectingHtmlElements[attr] && this.returnAttributeType(attr) === 'date')
      return `if (response.body.query.${attr}) {const ${attr}IsoFormat = new Date(response.body.query.${attr}); document.querySelector('[annotationname = ${attr}]').${element} = ${attr}IsoFormat.getDate()+'-'+${attr}IsoFormat.getMonth()+'-'+${attr}IsoFormat.getFullYear();} else {document.querySelector('[annotationname = ${attr}]').${element}='';}`;
    if (this.effectingHtmlElements[attr])
      return `document.querySelector('[annotationname = ${attr}]').${element} = response.body.query.${attr} ;`;
    if (this.effectingArrayInputElements[attr])
      return `initialize${element}(response.body.query.${attr}|| []) ; `;
    return '/** something went wrong */;';
  };

  nextFunction;

  apiCallPromisified = '';

  entityName = '';

  importModelParameter = [];

  modelNames = [];

  attributeArray = [];

  effectingHtmlElements = {};

  effectingArrayInputElements = {};

  constructor(method, annotations, htmlDom) {
    super(method, annotations);
    this.inputHtmlElement = method.inputHtmlElement || '';
    this.htmlNames = method.entityAttributes || '';
    this.apiCallPromisified = method.apiCallPromisified || '';
    this.entityName = method.entityName || '';
    this.importModelParameter = method.importModelParameter || [];
    this.modelNames = method.modelNames || [];
    this.attributeArray = this.getMapOfEntitiesToAttributes().get(method.entityName) || [];
    this.setTheEffectingElements(this.attributeArray, htmlDom);
  }

  setTheEffectingElements(attributeArray, htmlDom) {
    const arrayInputElements = getHtmlTableAttributes({ tableAttributes: attributeArray, htmlDom });
    const commonAttributes = attributeArray.filter(
      (attr) => ![...arrayInputElements.keys()].includes(attr)
    );
    this.effectingHtmlElements = this.getTheHtmlElements(commonAttributes, htmlDom) || {};
    this.effectingArrayInputElements = Object.fromEntries(arrayInputElements);
  }

  printImportStatement() {
    return this.apiInstance + this.importStatement + this.importModelParameter;
  }

  readTheUrlAsJsCommad() {
    return `let ${this.entityName}Id = window.location.pathname.replace('/${this.pageName}/','');`;
  }

  printFunction() {
    // first add this should add the inputId parameter code
    // this.functionality += this.returnParametesFromHtmlElements();
    // second  add the apiCallPromisified
    this.functionality += this.readTheUrlAsJsCommad();
    const tempEntity = this.entityName;
    this.functionality += `let ${tempEntity} = new TempApi.${
      tempEntity.charAt(0).toUpperCase() + tempEntity.slice(1)
    }();`;
    this.functionality += this.returnParametesFromHtmlElements(this.inputTemplate, this.entityName);
    this.functionality += ` let opts = {${tempEntity}};`;
    this.functionality += this.apiCallPromisified;

    this.functionality = this.functionality.replace(
      this.functionNextTemplate,
      this.returnParametesFromHtmlElements(this.outputTemplate, '') + this.functionNextTemplate
    );
    // third if it exist the next functionName
    this.printNextFunctionCode();
    // fourth clear the next template
    super.clearfunctionNextTemplate();
    // console.log(this.functionality);
    return this.functionality;
  }

  printNextFunctionCode() {
    if (this.nextFunction)
      this.functionality = this.functionality.replace(
        this.functionNextTemplate,
        this.nextFunction.printFunction({ typeId: 'response.body.query._id' })
      );
  }

  printNextFunctionCode() {
    if (this.nextFunction)
      if(this.nextFunction.transitionById === true){
        this.functionality = this.functionality.replace(
          this.functionNextTemplate,
          this.nextFunction.printFunction({ typeId: 'response.body.query._id' })
        );
      }
      else{
        this.functionality = this.functionality.replace(
          this.functionNextTemplate,
          this.nextFunction.printFunction({ typeId: '' })
        );
      }      
  }

  getTheHtmlElements(attributeArray, htmlDom) {
    return attributeArray.reduce((obj, attribute) => {
      const htmlTag =
        htmlDom.querySelector(`[annotationname = '${attribute}']`)?.tagName.toLowerCase() || '';
      const htmlAttr = this.htmlTagsToAttributes.get(htmlTag) || '';
      if (!htmlAttr) return { ...obj };
      return { ...obj, [attribute]: htmlAttr };
    }, {});
  }

  // TODO this needs refactoring
  returnParametesFromHtmlElements(template, entityName) {
    let js = '';
    js = this.attributeArray.reduce((acc, attribute) => {
      if (this.effectingHtmlElements[attribute])
        return acc + entityName + template(attribute, this.effectingHtmlElements[attribute]);
      if (this.effectingArrayInputElements[attribute])
        return acc + entityName + template(attribute, this.effectingArrayInputElements[attribute]);
      return acc;
    }, '');
    return js;
  }
}
